


import { defineComponent, onMounted, ref, onBeforeUnmount, onUnmounted, watch, computed } from 'vue';
import { LocalService, MessageService } from '../../../../../../../common/infrastructure/servicios';
import { MessageType } from '../../../../../../../common/infrastructure/servicios/MessageService';
import { IapComponentDataSource } from '../../../../../component/domain/iapComponentDataSource';
import ComponentCommon from '../../../../domain/Functions/ComponentCommon';
import { Container } from 'inversify';
import WidgetComponentDataTree from '../../../../../designer/domain/widgetComponent';
import { IapComponentAttribute } from '../../../../../component/domain/iapComponentAttribute';
import { IapCatalogType } from '../../../../../catalog/domain/iapCatalogType';
import LookUpEditorTypeConst from '../../../../domain/Constants/LookUpEditorTypeConst';
import LookUpEditor from '../../../../../crud/infrastructure/search/LookUpEditor.vue';
import { Dictionary } from '../../../../../expression/domain/dictionary';
import { SearchData } from '../../../../../search/domain/search';
import CatalogObjectTypeConst from '../../../../../catalog/domain/const/CatalogObjectTypeConst';
import CatalogExpConst from '../../../../../catalog/domain/const/CatalogExpConst';
import { IapDataSourceField } from '@ilinium/shared/src/entidades/builder/datasource/domain/iapDataSourceField';
import HelperCommon from '../../../../../../../common/infrastructure/funciones/HelperCommon';
import { IapCatalog } from '../../../../../catalog/domain/iapCatalog';
import ExpressionNomenclatorConst from '../../../../../expression/domain/const/ExpressionNomenclatorConst';
import CustomValidate from '../../shared/CustomValidate.vue';
import { InteractionEvent } from '../../../../../interaction/domain/interactionEvent';
import InteractionConst from '../../../../../interaction/domain/interactionConst';
import EventConst from '@ilinium/shared/src/common/domain/constantes/EventConst';
import EventBus from '../../../../../../../common/infrastructure/event-bus';
import { IapExpression } from '@ilinium/shared/src/entidades/builder/expression/domain/iapExpression';
import CatalogEventConst from '../../../../../catalog/domain/const/CatalogEventConst';
import { useStore } from 'vuex';	

export default defineComponent({
    name: 'dynamic_look_up',
    components: {
        LookUpEditor,
        CustomValidate
    },
    props:
    {
        container: {
            type: Object as () => Container
        },
        Component: {
            type: Object as () => WidgetComponentDataTree,
            default: () => ({})
        },
        rootParentId:
        {
            type: Number,
            default: (-1)
        },
        dataSources: {
            type: Object as () => IapComponentDataSource[],
            default: () => ({})
        },
        slotProps: {
            type: Object,
            default: () => ({})
        },
        rootParentAttr: {
            type: Object as () => IapComponentAttribute[],
            default: () => ({})
        },
        hasDetail: {
            type: Boolean,
            default: false
        }


    },
    setup(props, context) {
        //
        
        const store = useStore();
        const filterExpression = ref(false);
        const filterConditions = ref<Partial<SearchData>[]>([]);
        const opDetails = ref();
        const opViewDetails = ref(false);


        const { vmodel, lookUpData, getPropertyValue,getPropertyId, getPropertyValueOptions, getPropertyBooleanValue, loaded, componentData, resolveExpressions,
            baseOnBeforeUnmount, baseOnMounted, baseOnUnmount, v$, submitted, isValidData, canEdit, getDsLookUpId, getDsFieldsLookUp, getDsLookUp,
            fieldKey, fieldKeyComponentDataSourceId, getComponentDataSourceFromModelValue, resolveDatasource, getDsLookUpDesc, catalogTypes,
            processEventComponent, processEvent } = ComponentCommon(props, context,store);

        const isVisible = computed(() => {
            return loaded.value && filterExpression.value && getPropertyBooleanValue(LookUpEditorTypeConst.VISIBLE)
        })


        const hasCommand = computed(()=>{
            
            const propsIdCmd = getPropertyId(LookUpEditorTypeConst.CMD) ?? '';
            if (propsIdCmd){
                return (props.Component.workFlows?.find(x=> x.idObjeto == CatalogObjectTypeConst.ATTRCOMP && x.objetoId == propsIdCmd && x.active == true ) != undefined)
            }
            return false;

        })

        const clickf = ref(new Function());

        const clicktest = () => {
            // eval(' showMessage("click del boton"); alert("hola");')
        }
        const showMessage = (msg: string) => {
            MessageService.showToast(MessageType.Correcto, '', msg)
        }

        const selectedLookUpData = (data: any) => {
            lookUpData.value = data;
            processEventComponent(CatalogEventConst.CHANGE)
        }

        const getDsfByTableAndField = (tableField: string, cds: IapComponentDataSource | undefined | null): IapDataSourceField | undefined => {
            //const fieldsValue = tableField.split('.');


            const fields = getDsFieldsLookUp();

            const lookUpId = getDsLookUp()?.id;


            if (fields && !HelperCommon.isNullOrWhitespace(tableField)) {
                const dsf = fields.find(dsf => '[' + ExpressionNomenclatorConst.EXPNOM_DSLK + '.' + (lookUpId ? lookUpId : 0) + '.' + dsf.id + ']' == tableField);

                if (dsf) {
                    return dsf;
                }

            }

        }

        function isValidLength(arr: any[]): boolean {
            return arr.length % 3 === 0;
        }


        watch(
            loaded, (newvalue, oldvalue) => {
                if (oldvalue !== newvalue && newvalue == true && !filterExpression.value) {
                    resolveExpConditions();
                }
            },
            {
                flush: 'post',
                //immediate: true, 
                deep: true
            }
        )

        const resolveExpConditions = async () => {

            
            const cds = getComponentDataSourceFromModelValue();
            const componentDataSourceId = cds?.id;
            const dataSourceFieldId = cds?.dataSource?.iapDataSourceFields?.find(dsf => dsf.dataSourceLookUpId == getDsLookUpId())?.id;


            if (cds) {
                const compsrefs = [cds.componentId] //JSON.parse(LocalService.getValue(LocalService.COMPONENTS_CTRL + (props?.rootParentId ?? -1).toString()) ?? '[]')


                var promises = new Array();

                compsrefs.filter((value, index, array) => array.indexOf(value) === index).forEach((comp: number) => {

                    promises.push(createPromiseExpression(comp, (comp === props.rootParentId)));
                });

                let exps: IapExpression[] = [];

                await Promise.all(promises).then((responses: InteractionEvent[]) => {

                    if (responses.length > 0 && responses.filter(x => x.interactionResult).length > 0) {
                        exps = responses.filter(x => x.interactionResult).flatMap(x => x.interactionResult).filter(x => x.idTypeExpression == CatalogExpConst.EXP_FILTERLK)
                    }

                })



                if (exps.filter(x => x).length > 0) {
                    const result = resolveExpressions(CatalogObjectTypeConst.DSF, [dataSourceFieldId, componentDataSourceId].join('#'), CatalogExpConst.EXP_FILTERLK, exps.filter(x => x));

                    if (result) {
                        const resultArr = result.split('#');

                        if (resultArr && isValidLength(resultArr))

                            for (let i = 0; i < resultArr.length; i += 3) {

                                const dsf = getDsfByTableAndField(resultArr[i], cds);

                                if (dsf) {

                                    const filter = {
                                        field: dsf,
                                        filter: resultArr[i + 1],
                                        value: resultArr[i + 2],
                                        valueList: (dsf.catalogTypeId ? [resultArr[i + 2]] : null),
                                        valueBool: null,
                                        valueNumber: null,
                                        valueDateTime: null,
                                        rangeValue: null,
                                        rangeNumber: null,
                                        rangeDateTime: null

                                    }
                                    // metemos nuevo filtro
                                    filterConditions.value.push(filter as any);

                                }



                            }

                    }
                }


                filterExpression.value = true;
            }


        }


        const createPromiseExpression = async (compId: number, isRootparentId: boolean): Promise<InteractionEvent> => {


            return await new Promise<InteractionEvent>((resolve, reject) => {
                var data: Partial<InteractionEvent> = {
                    typeId: InteractionConst.CALL_FUNCTION,
                    objectName: 'getcurrentexpr()'

                }
                const keyComponentEventBus = (isRootparentId ? '' : props.rootParentId.toString()) + compId.toString() + EventConst.INTERACTION;


                var doCallbackOk = (response: InteractionEvent) => {
                    resolve(response);
                }

                EventBus.emit(keyComponentEventBus, { data: data, callBackResponse: doCallbackOk });


            });


        };

        const openDetail = () => {
            
            if (props.hasDetail){
                opViewDetails.value = true
            }
            else{
                processEvent(CatalogObjectTypeConst.ATTRCOMP, getPropertyId(LookUpEditorTypeConst.CMD) ?? '')
            }
            
        }

        onMounted(() => {
            baseOnMounted();
        })

        onBeforeUnmount(() => {
            baseOnBeforeUnmount();
        })

        onUnmounted(() => {
            baseOnUnmount();
        })


        return {
            clickf,
            MessageService,
            MessageType,
            showMessage,
            clicktest,
            getPropertyValue,
            getPropertyBooleanValue,
            vmodel,
            loaded,
            LookUpEditorTypeConst,
            getDsLookUpId,
            getDsLookUp,
            selectedLookUpData,
            fieldKey,
            fieldKeyComponentDataSourceId,
            filterConditions,
            filterExpression,
            isVisible,
            getDsLookUpDesc,
            opDetails,
            opViewDetails,
            openDetail,
            catalogTypes,
            isValidData,
            submitted,
            v$,
            hasCommand

        };
    },
});
